/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {
  Application,
  Link,
  Role,
  User
} from '@ion/core/src/types/entities';
import {
  APPLICATION_INITIALIZATION_COMPLETE,
  APPLICATION_INITIALIZATION_ERROR,
  APPLICATION_INITIALIZATION_REQUEST,
  POST_INITIALIZATION_COMPLETE,
  PRE_INITIALIZATION_COMPLETE,
  REFRESH_INITIALIZATION_COMPLETE
} from '../actions/initialization';

// defines the shape of this reducers state ...
export interface InitializationState {
  preInitializationComplete: boolean;
  isInitializing: boolean;
  initializationComplete: boolean;
  postInitializationComplete: boolean;
  user: User;
  application: Application;
  accounts: Link[];
  role: Role;
}

// defines the initial state for the reducer ...
const initialState: InitializationState = {
  preInitializationComplete  : false,
  initializationComplete     : false,
  postInitializationComplete : false,
  isInitializing             : false,
  user                       : null,
  accounts                   : null,
  application                : null,
  role                       : null
};

/**
 * The initialization reducer is responsible for persisting all initialization and
 * globally shared state.
 */
const reducers = {
  [PRE_INITIALIZATION_COMPLETE] : (draft: InitializationState) => {
    draft.preInitializationComplete = true;
  },
  [APPLICATION_INITIALIZATION_REQUEST] : (draft: InitializationState) => {
    draft.isInitializing = true;
  },
  [APPLICATION_INITIALIZATION_COMPLETE] : (draft: InitializationState, {user}) => {
    draft.isInitializing         = false;
    draft.initializationComplete = true;
    draft.user                   = user;
  },
  [APPLICATION_INITIALIZATION_ERROR] : (draft: InitializationState, {user}) => {
    draft.isInitializing = false;
  },
  [POST_INITIALIZATION_COMPLETE] : (draft: InitializationState) => {
    draft.postInitializationComplete = true;
  },
  [REFRESH_INITIALIZATION_COMPLETE] : (draft: InitializationState, {accounts}) => {
    draft.accounts = accounts;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: InitializationState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
